<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :meun="meunItem" :title="meunTitle" :title2="headTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <h3 class="title">{{ headTitle }}</h3>
            <div class="aLine"></div>
            <div class="tableInfo">
              <div class="input_div">
                <p>排序</p>
                <el-input class="input" type="number" onkeyup="value=value.replace(/\D/g,'')" v-model="info.order" placeholder="请输入"></el-input>
              </div>
              <div class="input_div">
                <p>轮播图标题</p>
                <el-input class="input" v-model="info.title" placeholder="请输入"></el-input>
              </div>
              <div class="input_div">
                <p>状态</p>
                <el-select style="width: 100%" v-model="info.status" placeholder="请选择" collapse-tags>
                  <el-option v-for="item in statusOptions" :key="item.en" :value="item.en" :label="item.cn"></el-option>
                </el-select>
              </div>
              <div class="input_div">
                <p>类型</p>
                <el-select style="width: 100%" v-model="info.type" placeholder="请选择" collapse-tags @change="changeType">
                  <el-option v-for="item in typeOptions" :key="item.en" :value="item.en" :label="item.cn"></el-option>
                </el-select>
              </div>
              <div class="input_div">
                <p>链接</p>
                <el-input v-if="info.type == 'link'" class="input" v-model="info.link" placeholder="请输入链接"></el-input>
                <el-select v-else-if="info.type != 'link'" style="width: 100%" v-model="info.link" placeholder="请选择" collapse-tags>
                  <el-option v-for="item in linkOptions" :key="item.id" :value="item.id" :label="item.title"></el-option>
                </el-select>
              </div>
              <div style="clear: both"></div>
              <div class="input_div">
                <input type="file" accept="image/*" style="display: none" id="uploadfile" @change="openFolder" />
                <el-button size="mini" @click="openImage()">选择本地图片</el-button>
                <el-image class="imageDiv" :src="imageUrl" fit="scale-down">
                  <div slot="error" class="image-slot" style="position: absolute; top: 50%; left: 50%">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </div>
          </div>
          <!-- <div class="footSubmit">
            <el-button
              style="float: right; margin-right: 30px"
              size="small"
              type="primary"
              @click="saveEdit()"
              >提交</el-button
            >
            <el-button
              style="float: right; margin-right: 15px"
              size="small"
              @click="toCancel()"
              >取消</el-button
            >
          </div> -->
          <FootLayout v-on:saveEdit="saveEdit"></FootLayout>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from '@/utils/strUtils.js'
import * as Constant from '@/utils/constant.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
import { URL_PATH } from '@/config/config'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayoutWxapp'
import FootLayout from '@/components/layout/footLayout'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    FootLayout
  },
  data() {
    return {
      meunItem: null,
      meunTitle: '',
      headTitle: '',
      urlPath: URL_PATH,
      imageUrl: '',
      info: { order: 10000, link: '' },
      statusOptions: Constant.options_status,
      typeOptions: Constant.options_type,
      linkOptions: []
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.infoId = this.$route.query.id
      this.headTitle = this.infoId == null ? '新增轮播图' : '编辑轮播图'
      this.getInfo()
    },
    // 获取详情
    getInfo() {
      var id = this.$route.query.id
      if (id == null) return
      this.$api
        .bannerInfo({
          token: localStorage.getItem('token'),
          banner_id: id
        })
        .then(({ data }) => {
          this.info = data.Data
          this.imageUrl = this.urlPath + this.info.image_link
          if (this.info.type != 'link') {
            this.info.link = parseInt(this.info.link)
            this.getBannerLink()
          }
        })
        .catch(({ error }) => {})
    },
    // 获取链接参数接口
    getBannerLink: function () {
      if (this.info.type == 'link') return
      this.$api
        .getBannerLink({
          token: localStorage.getItem('token'),
          type: this.info.type
        })
        .then(({ data }) => {
          this.linkOptions = data.Data
        })
        .catch(({ error }) => {})
    },
    // 新增
    addBanner: function (form) {
      this.$api
        .updateBanner(form)
        .then(({ data }) => {
          this.$router.back(-1)
        })
        .catch(({ error }) => {})
    },
    // 编辑
    updateBanner: function (form) {
      form.append('id', this.info.id)
      this.$api
        .updateBanner(form)
        .then(({ data }) => {
          this.$router.back(-1)
        })
        .catch(({ error }) => {})
    },
    // 选择类型
    changeType(select) {
      this.info.link = ''
      this.getBannerLink()
    },
    // 选择图片
    openImage() {
      document.getElementById('uploadfile').click()
    },
    openFolder(e) {
      var that = this
      var image = e.target.files[0]
      var reader = new FileReader()
      reader.onload = function (evt) {
        that.imageUrl = evt.target.result
      }
      reader.readAsDataURL(image)
      this.info.image_link = image
    },
    // 保存
    saveEdit() {
      if (
        StrUtils.isEmpty(this.info.type) ||
        StrUtils.isEmpty(this.info.title) ||
        StrUtils.isEmpty(this.info.status) ||
        StrUtils.isEmpty(this.info.order) ||
        StrUtils.isEmpty(this.info.image_link)
      ) {
        this.$message.error('请先完善数据')
        return
      }
      if (this.info.type !== 'link' && StrUtils.isEmpty(this.info.link)) {
        this.$message.error('请先完善数据')
        return
      }
      if (this.info.type == 'link' && this.info.link && this.info.link.indexOf('http') != 0) {
        this.$message.error('请输入有效链接')
        return
      }
      var form = new FormData()
      form.append('token', localStorage.getItem('token'))
      form.append('type', this.info.type)
      form.append('link', this.info.link)
      form.append('title', this.info.title)
      form.append('status', this.info.status)
      form.append('order', this.info.order)
      form.append('image', this.info.image_link)
      if (this.infoId) {
        this.updateBanner(form)
      } else {
        this.addBanner(form)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-top: 24px;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.operateText {
  font-size: 14px;
}

.input_div {
  width: 290px;
  margin-right: 120px;
  margin-bottom: 32px;
  float: left;
}
.input_div p {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
  margin-bottom: 8px;
}
</style>

 <style lang="less">
/* element样式重置 start */
/* 去掉input尾部上下小箭头 start */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type='number'] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
/* 去掉input尾部上下小箭头 end */
</style>



// WEBPACK FOOTER //
// src/pages/wxapp/bannerAdd.vue